import { render, staticRenderFns } from "./mulDetail.vue?vue&type=template&id=0f6a96e0&scoped=true&"
import script from "./mulDetail.vue?vue&type=script&lang=js&"
export * from "./mulDetail.vue?vue&type=script&lang=js&"
import style0 from "./mulDetail.vue?vue&type=style&index=0&id=0f6a96e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a96e0",
  null
  
)

export default component.exports